/**
 * Registers an ellipsis filter to the provided filters object.
 * This filter truncates text to a specified length and appends an ellipsis.
 * 
 * @param {Object} filters - The filters object to which the ellipsis filter will be registered.
 */
export default function registerEllipsisFilter(filters) {
    /**
     * Registers the 'ellipsis' filter to the provided filters object.
     * 
     * @param {string} name - The name of the filter, which is 'ellipsis'.
     * @param {Function} factory - The factory function that returns the filter function.
     */
    filters.filter('ellipsis', function() {
        /**
         * The filter function that truncates text and appends an ellipsis.
         * 
         * @param {string} text - The text to be truncated.
         * @param {number} length - The maximum length of the text before truncation.
         * @param {string} suffix - The suffix to append after truncation (default is "...").
         * @returns {string} The truncated text with the suffix appended.
         */
        return function (text, length, suffix) {
            // SMELL: Magic number '50' is used without explanation. Consider defining a constant.
            if (isNaN(length))
                length = 50;

            // SMELL: Default value for suffix is hardcoded. Consider defining a constant.
            if (suffix === undefined)
                suffix = "...";

            // Check if the text length is within the allowed length or if the text length minus suffix length is within the allowed length
            if (text.length <= length || text.length - suffix.length <= length) {
                return text;
            }
            else {
                // Truncate the text and append the suffix
                return String(text).substring(0, length) + suffix;
            }
        };
    });
}